// extracted by mini-css-extract-plugin
export default {"details":"Details_details__FhKSu","details__content":"Details_details__content__IZHv1"};